<script setup>
/* eslint-disable */
import { ref, computed, watch } from 'vue';
import { useI18n } from 'vue-i18n';

const props = defineProps({
	modelValue: {
		type: String,
		default: 'popular'
	}
});

const emit = defineEmits(['update:modelValue', 'change']);

const { t } = useI18n();

const selected_fixture_order = ref(props.modelValue || 'popular');
const show_fixture_order_selector = ref(false);

const fixture_order_options = computed(() => [
	{ value: 'time', label: t('general.time_first') || 'Χρονικά πρώτα' },
	{ value: 'popular', label: t('general.popular_first') || 'Δημοφιλή πρώτα' }
]);

const selected_fixture_order_label = computed(() => {
	const found = fixture_order_options.value.find(opt => opt.value === selected_fixture_order.value);
	return found ? found.label : fixture_order_options.value[0].label;
});

watch(() => props.modelValue, (newVal) => {
	if (newVal) {
		selected_fixture_order.value = newVal;
	}
});

const selectFixtureOrder = (option) => {
	selected_fixture_order.value = option.value;
	emit('update:modelValue', option.value);
	emit('change', option.value);
	show_fixture_order_selector.value = false;
};

const closeFixtureOrderSelector = () => {
	show_fixture_order_selector.value = false;
};
</script>

<template>
	<div class="dashboard-info-label dropdown-option-top dropdown-option-order">
		<div class="select-option">
			<dl class="drop fixture-order-drop" :class="{ active: show_fixture_order_selector }">
				<dt>
					<button type="button" class="tablinks order-btn" @click="show_fixture_order_selector = !show_fixture_order_selector" v-click-outside-element="closeFixtureOrderSelector">
						<svg class="sort-icon-svg" xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
							<path d="M11 5h10"/>
							<path d="M11 9h7"/>
							<path d="M11 13h4"/>
							<path d="M3 17l3 3 3-3"/>
							<path d="M6 18V4"/>
						</svg>
						<span class="order-label-text">{{ selected_fixture_order_label }}</span>
						<span class="tabIco inline-arrow">
							<svg xmlns="http://www.w3.org/2000/svg" width="8" height="6" viewBox="0 0 4 3">
								<g id="Group_73" data-name="Group 73" transform="translate(-134 -568)">
									<path id="Polygon_2" data-name="Polygon 2" d="M2,0,4,3H0Z" transform="translate(138 571) rotate(180)" fill="currentColor" />
								</g>
							</svg>
						</span>
					</button>
				</dt>
				<dd>
					<ul>
						<li v-for="option in fixture_order_options" :key="option.value" @click="selectFixtureOrder(option)" :class="{ active: selected_fixture_order === option.value }">
							<button type="button" class="tablinks">{{ option.label }}</button>
						</li>
					</ul>
				</dd>
			</dl>
		</div>
	</div>
</template>
<style scoped>
.order-btn {
	display: inline-flex;
	align-items: center;
	gap: 6px;
	white-space: nowrap;
}

.order-label-text {
	white-space: nowrap;
}

.select-option {
	width: auto;
}

.dropdown-option-order .select-option .drop dd ul,
.fixture-order-drop dd ul {
	min-width: 120px;
	width: max-content;
	right: 0 !important;
	left: auto !important;
	box-shadow: 0 4px 12px rgba(0, 0, 0, 0.4);
	border-radius: 4px;
	z-index: 1000 !important;
}

.dropdown-option-order .select-option .drop dd ul li,
.fixture-order-drop dd ul li {
	white-space: nowrap;
}

.dropdown-option-order .select-option .drop dd ul li button,
.fixture-order-drop dd ul li button {
	white-space: nowrap;
	width: 100%;
	text-align: left;
}

:dir(rtl) .dropdown-option-order .select-option .drop dd ul,
:dir(rtl) .fixture-order-drop dd ul,
html[dir="rtl"] .dropdown-option-order .select-option .drop dd ul,
html[dir="rtl"] .fixture-order-drop dd ul {
	right: auto !important;
	left: 0 !important;
}

:dir(rtl) .dropdown-option-order .select-option .drop dd ul li button,
:dir(rtl) .fixture-order-drop dd ul li button,
html[dir="rtl"] .dropdown-option-order .select-option .drop dd ul li button,
html[dir="rtl"] .fixture-order-drop dd ul li button {
	text-align: right;
}
</style>